import React, { FunctionComponent, useContext } from 'react';
import { AgFinancingMatricula } from '@indigo-ag/schema';
import { SmallTitle } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import { getAgFinancingMatriculas } from 'features/brazil-grower/queries';
import {
  biomeTypesOptions,
  EnhancedExpansionPanel,
  evaluationTypesOptions,
  GridContainer,
  GridContainerItem,
  LoadingWrapper,
  parseNumberToLocale,
  utils
} from 'shared';

const getEvaluationText = (value: string | undefined) => {
  return value ? evaluationTypesOptions.find(e => e.value === value)?.name : '-';
};

export const FieldMonitoringMatriculasDetailSummary: FunctionComponent = () => {
  /**
   * Finance Process Context
   */
  const { agFinancingId } = useContext(FinanceProcessContext);

  return (
    <LoadingWrapper query={getAgFinancingMatriculas} queryOptions={{ variables: { agFinancingId } }}>
      {({ data }: { data: { findAgFinancingMatriculas: AgFinancingMatricula[] } }) => {
        return (
          <>
            <SmallTitle className="mb-2">{i18next.t('matriculas')}</SmallTitle>
            {data.findAgFinancingMatriculas.map(mat => {
              const detail = mat.details?.find(d => !!d.id);
              const biomeNameValue = detail?.biome ? biomeTypesOptions.find(o => o.value === detail?.biome)?.name : '-';

              const fieldMonitoringDataGridItems: GridContainerItem[] = [
                {
                  label: i18next.t('emissionDate'),
                  value: detail?.emissionDate ? utils.date.formatDate(detail.emissionDate) : '-'
                },
                {
                  label: i18next.t('state'),
                  value: detail?.state?.name || '-'
                },
                {
                  label: i18next.t('totalArea'),
                  value: detail?.totalArea ? parseNumberToLocale(detail?.totalArea) : '-'
                },
                {
                  label: i18next.t('cultivableArea'),
                  value: detail?.cultivableArea ? parseNumberToLocale(detail?.cultivableArea) : '-'
                },
                {
                  label: i18next.t('farmName'),
                  value: detail?.farmName
                },
                {
                  label: i18next.t('biome'),
                  value: biomeNameValue
                },
                {
                  label: i18next.t('preservationArea'),
                  value: detail?.preservationArea || '-'
                },
                {
                  label: i18next.t('otherArea'),
                  value: detail?.otherArea || '-'
                },
                {
                  label: i18next.t('complianceConflictArea'),
                  value: detail?.complianceConflictArea || '-'
                },
                {
                  label: i18next.t('ibamaEmbargo'),
                  value: getEvaluationText(detail?.ibamaEmbargo)
                },
                {
                  label: i18next.t('conservationUnities'),
                  value: getEvaluationText(detail?.conservationUnities)
                },
                {
                  label: i18next.t('indigenousLand'),
                  value: getEvaluationText(detail?.indigenousLand)
                },
                {
                  label: i18next.t('ICMBIOEmbargo'),
                  value: getEvaluationText(detail?.ICMBIOEmbargo)
                },
                {
                  label: i18next.t('stateEmbargo'),
                  value: getEvaluationText(detail?.stateEmbargo)
                },
                {
                  label: i18next.t('quilimbolasLand'),
                  value: getEvaluationText(detail?.quilimbolasLand)
                }
              ];
              return (
                <EnhancedExpansionPanel title={<SmallTitle>{mat.matricula?.documentName}</SmallTitle>}>
                  <GridContainer columns={3} items={fieldMonitoringDataGridItems} />
                </EnhancedExpansionPanel>
              );
            })}
          </>
        );
      }}
    </LoadingWrapper>
  );
};
